/* istanbul ignore file */
import { round, map, uniq } from "lodash";
import getNumericValue from "./getNumericValue";
import { getPogCost } from "./pogCalculation";

export const getItemLevelSummations = (
  rows = [],
  selections = [],
  isGrandTotal = false,
  pogIdList = []
) => {
  let initialSummations = {
    footage: 0,
    pogSkus: 0,
    pogQty: 0,
    pogCost: 0,
    missingSkus: 0,
    adjQty: 0,
    adjCost: 0,
    totalCost: 0,
    orderQty: 0,
    orderCost: 0,
  };
  for (let i = 0; i < rows.length; i++) {
    const item = rows[i];
    if (
      selections?.includes(String(item.id)) ||
      selections?.includes(item.id)
    ) {
      // Pog level Summation
      if (!item.Item_Nbr) {
        // isGranTotal: pog level we need cost based on item required qty.
        // but for grand summation we just need pog cost for summation
        const calculatedPogCost = isGrandTotal
          ? item.pogcost
          : getPogCost(item);
        initialSummations = {
          ...initialSummations,
          ...(!pogIdList.includes(item?.PlanogramNumber) &&
            isGrandTotal && {
              footage: round(
                (initialSummations.footage += getNumericValue(
                  item?.footage,
                  "ft"
                )),
                2
              ),
              pogSkus: round(
                (initialSummations.pogSkus += getNumericValue(item?.pogsku)),
                2
              ),
              pogQty: round(
                (initialSummations.pogQty += getNumericValue(item?.pogqty)),
                2
              ),
            }),
          pogCost: round(
            (initialSummations.pogCost += getNumericValue(
              calculatedPogCost,
              "$"
            )),
            2
          ),
          missingSkus: round(
            (initialSummations.missingSkus += getNumericValue(
              item?.missingskus
            )),
            2
          ),
          adjQty: round(
            (initialSummations.adjQty += getNumericValue(item?.adjqty)),
            2
          ),
          adjCost: round(
            (initialSummations.adjCost += getNumericValue(item?.adjcost, "$")),
            2
          ),
          totalCost: round(
            (initialSummations.totalCost += getNumericValue(
              item?.totalCost,
              "$"
            )),
            2
          ),
          orderQty: round(
            (initialSummations.orderQty += getNumericValue(item?.orderQty)),
            2
          ),
          orderCost: round(
            (initialSummations.orderCost += getNumericValue(
              item?.orderCost,
              "$"
            )),
            2
          ),
        };
      } else {
        // Item level Summation
        const calculatedPogCost = getPogCost(item);
        initialSummations = {
          ...initialSummations,
          footage: round(
            (initialSummations.footage += getNumericValue(item?.footage, "ft")),
            2
          ),
          pogSkus: round(
            (initialSummations.pogSkus += getNumericValue(item?.pogsku)),
            2
          ),
          pogQty: round(
            (initialSummations.pogQty += getNumericValue(item?.pogqty)),
            2
          ),
          pogCost: round(
            (initialSummations.pogCost += getNumericValue(
              calculatedPogCost,
              "$"
            )),
            2
          ),
          missingSkus: round(
            (initialSummations.missingSkus += getNumericValue(
              item?.missingskus
            )),
            2
          ),
          adjQty: round(
            (initialSummations.adjQty += getNumericValue(item?.adjqty)),
            2
          ),
          adjCost: round(
            (initialSummations.adjCost += getNumericValue(item?.adjcost, "$")),
            2
          ),
          totalCost: round(
            (initialSummations.totalCost += getNumericValue(
              item?.totalCost,
              "$"
            )),
            2
          ),
          orderQty: round(
            (initialSummations.orderQty += getNumericValue(item?.orderQty)),
            2
          ),
          orderCost: round(
            (initialSummations.orderCost += getNumericValue(
              item?.orderCost,
              "$"
            )),
            2
          ),
        };
      }
    }
  }
  return initialSummations;
};

export const getPogLevelSummations = (pogDetails = {}, selections = {}) => {
  let initialSummations = {
    footage: 0,
    pogSkus: 0,
    pogQty: 0,
    pogCost: 0,
    missingSkus: 0,
    adjQty: 0,
    adjCost: 0,
    totalCost: 0,
    orderQty: 0,
    orderCost: 0,
  };
  const scopeList = Object.keys(pogDetails);
  let pogIdList = [];
  for (let i = 0; i < scopeList.length; i++) {
    const currentScope = scopeList[i];
    const pogList = pogDetails[currentScope];
    const entityWiseTotals = getItemLevelSummations(
      pogList,
      selections,
      true,
      pogIdList
    );
    pogIdList = [...pogIdList, ...map(pogList, "PlanogramNumber")];
    pogIdList = uniq(pogIdList);

    initialSummations = {
      ...initialSummations,
      footage: round(
        (initialSummations.footage += getNumericValue(
          entityWiseTotals?.footage,
          "ft"
        )),
        2
      ),
      pogSkus: round(
        (initialSummations.pogSkus += getNumericValue(
          entityWiseTotals?.pogSkus
        )),
        2
      ),
      pogQty: round(
        (initialSummations.pogQty += getNumericValue(entityWiseTotals?.pogQty)),
        2
      ),
      pogCost: round(
        (initialSummations.pogCost += getNumericValue(
          entityWiseTotals?.pogCost,
          "$"
        )),
        2
      ),
      missingSkus: round(
        (initialSummations.missingSkus += getNumericValue(
          entityWiseTotals?.missingSkus
        )),
        2
      ),
      adjQty: round(
        (initialSummations.adjQty += getNumericValue(entityWiseTotals?.adjQty)),
        2
      ),
      adjCost: round(
        (initialSummations.adjCost += getNumericValue(
          entityWiseTotals?.adjCost,
          "$"
        )),
        2
      ),
      totalCost: round(
        (initialSummations.totalCost += getNumericValue(
          entityWiseTotals?.totalCost,
          "$"
        )),
        2
      ),
      orderQty: round(
        (initialSummations.orderQty += getNumericValue(
          entityWiseTotals?.orderQty
        )),
        2
      ),
      orderCost: round(
        (initialSummations.orderCost += getNumericValue(
          entityWiseTotals?.orderCost,
          "$"
        )),
        2
      ),
    };
  }
  return initialSummations;
};
